
import { useState, useEffect } from 'react';
import { Control, FieldValues } from 'react-hook-form';
import InputField from './InputField';
import { getRoles } from '@/actions/data-fetch-settings';
import { SelectOption } from './InputFieldProps.d';

interface RoleSelectProps<TFieldValues extends FieldValues> {
    roleStyling?: string;
    name: string;
    control: Control<TFieldValues>;
    error?: string;
    required?: boolean;
    disabled?: boolean;
}

const RoleSelect = <TFieldValues extends FieldValues>({
    roleStyling,
    name,
    control,
    error,
    required = true,
    disabled = false 
}: RoleSelectProps<TFieldValues>) => {
    const [roleOptions, setRoleOptions] = useState<SelectOption[]>([
        { value: '', label: 'Select Role' }
    ]);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await getRoles();
                const roles = response?.data?.roles;

                if (!roles || !Array.isArray(roles)) {
                    console.error('Invalid roles data structure');
                    return;
                }

                const options: SelectOption[] = [
                    { value: '', label: 'Select Role' },
                    ...roles.map((role: any) => ({
                        value: role.uuid,
                        label: role.role_name
                    }))
                ];

                setRoleOptions(options);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };

        fetchRoles();
    }, []);

    return (
        <InputField
            label="Role"
            id={name}
            name={name}
            type="select"
            control={control}
            options={roleOptions}
            required={required}
            className={roleStyling}
            error={error}
            labelClass="lg:w-1/5"
            disabled={disabled}
        />
    );
};

export default RoleSelect;